<template>
	<div class="brick" :style="user.company_id == 'beautyplus' || user.company_id == 'hairplus' ? 'width:1885px;' : ''">
		<div class="list_top_box">
			<div class="left_option">
				<span class="int_type_no_border mgr_5" style="padding-top:3px;">
					<label class="mgr_5"><input type="radio" :value="null" v-model="invoice_type" v-on:change="search()" /> All</label>
					<label class="mgr_5"><input type="radio" value="S" v-model="invoice_type" v-on:change="search()" /> Sale</label>
					<label class="mgr_5"><input type="radio" value="R" v-model="invoice_type" v-on:change="search()" /> Return</label>
				</span>
				<span v-if="profile.use_temp_flag == 'Y'" class="int_type_no_border">
					<select v-model="temp_flag" class="tbl_select" style="width:80px;" @change="search()">
						<option :value="null">All</option>
						<option :value="0">NJ Only</option>
						<option :value="1">GA Only</option>
					</select>
				</span>
				<em class="lt_text">Inv. Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="invoice_date_from"/> ~ <CustomDatePicker v-model="invoice_date_to"/></span>

				<label for="void_invoice" style="margin-right:5px;"><input type="checkbox" @change="search()" v-model="void_invoice" id="void_invoice" />Void</label>

				<em class="lt_text">Country</em>
				<span class="int_type_no_border mgr_5">
					<CodeSelect :width="70" :showDesc="false" :codes="countries" v-model="country" @post-loading="postCoutryLoading" />
				</span>

				<em class="lt_text">State</em>
				<span class="int_type_no_border mgr_5"> <CodeSelect :width="70" :codeWidth="120" :showDesc="false" :codes="filteredStates" v-model="state" /> </span>

				<template v-if="user.company_id == 'newjigu'">
					<em class="lt_text">Territory</em>
					<span class="int_type_no_border mgr_5"> <CodeSelect :width="60" :codeWidth="120" :showDesc="false" :codes="territories" v-model="territory_code" /> </span>
				</template>

				<em class="lt_text">S.Group</em>
				<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" v-model="sales_group_code" :showDesc="false"/></span>

				<template v-if="isBPorHP">
					<em class="lt_text">S.Man</em>
					<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesmansForSearch" :showDesc="false" v-model="salesman_id"/></span>
				</template>

				<span class="int_type_no_border mgr_5"> <PartnerSelect v-model="ship_to_code" ph="Ship To" :customerOnly="true" :showName="false" @set-partner="setShipTo" /> </span>
				<span class="int_type_no_border mgr_5"> <PartnerSelect v-model="bill_to_code" ph="Bill To" :customerOnly="true" :showName="false" @set-partner="setBillTo" /> </span>

				<em class="lt_text">Dlvr.Type</em>
				<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="deliveryTypes" :showDesc="false" v-model="delivery_type_code"/></span>

				<span class="int_type sm_int"> <input type="text" v-model.trim="keyword" ref="keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" /> </span>

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt mgr_5" @click="reset()">Reset</a>
				<a href="javascript:void(0);" class="gray_bt" @click="invoicePrint()">Print</a>
				<router-link :to="{ name: 'invoiceDetail', params: { mode: 'add' }, query: { backUri: this.uri } }" class="gray_bt">Add</router-link>
			</div>
			<div v-if="abnormal_invoices.length > 0" class="left_option">
				<span class="blink" style="color:red; font-weight:bold;"
					><a href="javascript:;" @click="aiPopup()">Check Invoice(s) Amount ({{ abnormal_invoices.length }}). Click to View List</a></span
				>
			</div>
		</div>

		<table class="list_tbl" v-columns-resizable>
			<thead>
				<tr>
					<th width="10px;"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></th>
					<th :width="profile.use_temp_flag == 'Y' && user.temp_flag ? '180px;' : '70px;'">
						<a href="javascript:;" @click="sort('ship_to_code')">Ship To{{ sortMark('ship_to_code') }}</a>
					</th>
					<th v-if="user.company_id == 'newjigu'" width="145px;">Delivery Type</th>
					<th width="115px;">Name</th>
					<th :width="user.company_id == 'newjigu' ? '180px' : profile.use_temp_flag == 'Y' && user.temp_flag ? '180' : user.company_id == 'hairplus' ? '200px;' : '280px;'">Address</th>
					<th width="70px;">
						<a href="javascript:;" @click="sort('bill_to_code')">Bill To{{ sortMark('bill_to_code') }}</a>
					</th>
					<th width="115px;">Name</th>
					<th width="40px;" v-if="user.company_id == 'newjigu'">Terr</th>
					<th :width="user.company_id == 'newjigu' ? '100px' : profile.use_temp_flag == 'Y' && user.temp_flag ? '260px;' : '145px;'">
						<a href="javascript:;" @click="sort('invoice_dn')">Inv. No{{ sortMark('invoice_dn') }}</a>
					</th>
					<!-- <th width="1%">T.</th> -->
					<th width="10px;">Int'l</th>
					<th width="90px;">
						<a href="javascript:;" @click="sort('invoice_date')">Inv. Date{{ sortMark('invoice_date') }}</a>
					</th>
					<th width="105px;">
						<a href="javascript:;" @click="sort('so_dn')">S/O No{{ sortMark('so_dn') }}</a>
					</th>
					<th v-if="user.company_id == 'newjigu'" width="175px;">Cust. PO Number</th>
					<th width="90px;">S/O Date</th>
					<th v-if="user.company_id == 'hairplus'" width="80px;">
						<a href="javascript:;" @click="sort('payment_type')">Pay Term{{ sortMark('payment_type') }}</a>
					</th>
					<th width="105px;">Sales Group</th>
					<th v-if="isBPorHP" width="110px;">Sales Man</th>
					<th width="105px;" v-if="isBPorHP">Entry User</th>
					<th width="45px;">Qty.</th>
					<th width="45px;">Weight</th>
					<th width="80px;">Total Amt.</th>
					<th width="80px;">
						<a href="javascript:;" @click="sort('invoice_amount')">Inv. Amt.{{ sortMark('invoice_amount') }}</a>
					</th>
					<th width="40px;">Box</th>
					<th v-if="user.company_id != 'newjigu'" width="145px;">Delivery Type</th>
					<th>To Accounting</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="invoice in invoices" v-bind:key="invoice.invoice_no">
					<td class="al_center"><input type="checkbox" v-model="invoice.selected" /></td>
					<td class="al_left">
						<span v-if="profile.use_temp_flag == 'Y' && user.temp_flag && invoice.label_printed" style="color:blue;font-weight:bold;">LABEL PRINTED</span>
						<a href="javascript:;" @click="gotoPartner(invoice.ship_to_code)">{{ invoice.ship_to_code }}</a>
					</td>
					<td v-if="user.company_id == 'newjigu'" class="al_left truncate">
						{{ invoice.delivery_type_name }}
						<a href="javascript:;" v-if="invoice.status_code == 'I' && invoice.shipment_info_exists" @click="shipmentPopup(invoice)"
							>- <b><font color="blue">INFO</font></b></a
						>
					</td>
					<td class="al_left truncate" :title="invoice.ship_to_name">
						<a href="javascript:;" @click="gotoPartner(invoice.ship_to_code)">{{ invoice.ship_to_name }}</a>
					</td>
					<td class="al_left truncate" :title="invoice.ship_to_address1">
						{{ invoice.ship_to_address1 }}
					</td>
					<td class="al_left">
						<a href="javascript:;" @click="gotoPartner(invoice.bill_to_code)">{{ invoice.bill_to_code }}</a>
					</td>
					<td class="al_left truncate">
						<a href="javascript:;" @click="gotoPartner(invoice.bill_to_code)">{{ invoice.bill_to_name }}</a>
					</td>
					<td class="al_left" v-if="user.company_id == 'newjigu'">{{ invoice.territory_code }}</td>
					<td class="al_left">
						<span v-if="profile.use_temp_flag == 'Y' && user.temp_flag && invoice.invoice_print_user" style="color:blue;font-weight:bold;">INV. PRINTED</span>
						<a href="javascript:;" @click="selectInvoice(invoice)"
							><font :color="invoice.urgent_yn == 'Y' ? 'red' : 'black'">{{ invoice.invoice_dn }}</font></a
						>
						<a href="javascript:;" @click="viewItems(invoice)">(Item)</a>
					</td>
					<!-- <td class="al_center">
						<font :color="invoice.invoice_type == 'R' ? 'red' : 'black'">{{ invoice.invoice_type }}</font>
					</td> -->
					<td class="al_center">{{ invoice.international ? '&#10004;' : null }}</td>
					<td class="al_left">{{ invoice.invoice_date }}</td>
					<td class="al_left">
						<a href="javascript:;" @click="selectSO(invoice)"
							><font :color="invoice.urgent_yn == 'Y' ? 'red' : 'black'">{{ invoice.so_dn }}</font></a
						>
					</td>
					<td v-if="user.company_id == 'newjigu'" class="al_left">{{ invoice.customer_po_no }}</td>
					<td class="al_left">{{ invoice.so_date }}</td>

					<td v-if="user.company_id == 'hairplus'" class="al_left truncate" :title="invoice.payment_term_name">{{ invoice.payment_term_name }}</td>
					<td class="al_left">{{ invoice.sales_group_name }}</td>
					<td v-if="isBPorHP" class="al_left truncate" :title="invoice.salesman_name">{{ invoice.salesman_name }}</td>
					<td class="al_left truncate" v-if="isBPorHP" :title="invoice.crt_name">{{ invoice.crt_name }}</td>
					<td class="al_right">{{ invoice.total_shipped_quantity | commaSeparated }}</td>
					<td class="al_right">{{ invoice.total_weight | commaSeparated }}</td>
					<td class="al_right">{{ invoice.total_shipped_amount | toCurrency }}</td>
					<td class="al_right">{{ invoice.invoice_amount | toCurrency }}</td>
					<td class="al_right">{{ invoice.box_count | commaSeparated }}</td>
					<td v-if="user.company_id != 'newjigu'" class="al_left truncate">
						{{ invoice.delivery_type_name }}
						<a href="javascript:;" v-if="invoice.status_code == 'I' && invoice.shipment_info_exists" @click="shipmentPopup(invoice)"
							>- <b><font color="blue">INFO</font></b></a
						>
					</td>
					<td class="al_left">{{ invoice.remark }}</td>
				</tr>
				<tr>
					<td :colspan="user.company_id == 'newjigu' ? 15 : user.company_id == 'hairplus' ? 15 : isBPorHP ? 14 : 12" class="al_right"><font color="red">Total</font></td>

					<td class="al_right">
						<font color="red">{{ invoices_sum.total_shipped_quantity_sum | commaSeparated }}</font>
					</td>
					<td class="al_right">
						<font color="red">{{ invoices_sum.total_weight | commaSeparated }}</font>
					</td>
					<td class="al_right">
						<font color="red">{{ invoices_sum.total_shipped_amount_sum | toCurrency }}</font>
					</td>
					<td class="al_right">
						<font color="red">{{ invoices_sum.invoice_amount_sum | toCurrency }}</font>
					</td>
					<td class="al_right">
						<font color="red">{{ invoices_sum.box_count | commaSeparated }}</font>
					</td>
					<td></td>
					<td></td>
				</tr>
			</tbody>
		</table>
		<div style="text-align:right;padding-right:150px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="bottom_bt_box" style="margin-right:120px;">
			<a href="javascript: void(0);" class="gray_bt" @click="excelExportOfAllData(false)">Export List(Detail)</a>
			<a href="javascript: void(0);" class="gray_bt mgr_15" @click="excelExportListSimple()">Export List(Simple)</a>
			<a v-if="user.company_id == 'jc'" href="javascript:;" type="button" class="gray_bt mgr_15" @click="excelSBM()">SBM Excel</a>
			<a v-if="user.company_id == 'jc'" href="javascript:;" type="button" class="gray_bt mgr_15" @click="excelExportOfAllData(true)">Selected List Excel</a>
			<template v-if="user.company_id == 'minkhair'">
				<input type="text" class="tbl_int ssm_int" v-model.trim="from_invoice_no" placeholder="From Inv. No" autofocus autocomplete="off" />~
				<input type="text" class="tbl_int ssm_int" v-model.trim="to_invoice_no" placeholder="To Inv. No" autofocus autocomplete="off" />
				<a href="javascript: void(0);" class="gray_bt mgr_15" @click="excelItemList()">Export Item List</a>
			</template>
			<ul>
				<li v-if="user.invoice_date_modifiable" class="mgr_15">
					<a href="javascript:void(0);" type="button" @click="changeInvoiceDate()">Change Invoice Date</a>
				</li>
				<li><a href="javascript:void(0);" type="button" class="mgr_15" @click="invoicePrint()">Print</a></li>
				<li class="mgr_15">
					<PageSizeSelect v-model="page_size" @input="search()" />
				</li>
				<li style="margin-top:5px;">
					<label class="mgr_5"><input type="radio" :value="25" v-model="exportPercent" />25%</label>
				</li>
				<li style="margin-top:5px;">
					<label class="mgr_5"><input type="radio" :value="50" v-model="exportPercent" />50%</label>
				</li>
				<li style="margin-top:5px;">
					<label class="mgr_5"><input type="radio" :value="75" v-model="exportPercent" />75%</label>
				</li>
				<li><a href="javascript:;" type="button" class="mgr_15" @click="exportExcel()">Export(Commercial)</a></li>
				<li><router-link :to="{ name: 'invoiceDetail', params: { mode: 'add' }, query: { backUri: this.uri } }">Add</router-link></li>
			</ul>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'ChangeInvoiceDate'" :draggable="false">
			<template slot="title">Change Invoice Date</template>
			<template slot="body">
				<div style="width:360px; height:350px;" v-on:keyup.esc="close()">
					<CustomDatePicker v-model="to_change_invoice_date" />
					<div class="popup_bottom">
						<a href="javascript:;" @click="changeInvoiceDateConfirm()" class="normal_bt mgr_15">Confirm</a>
						<a href="javascript:;" @click="closeModal()" class="gray_bt">Cancel</a>
					</div>
				</div>
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'Shipment'" :draggable="false">
			<template slot="title">Shipment</template>
			<template slot="body">
				<!-- <ShipmentPopup :invoice_no="selected_invoice_no" :view_only="true" v-on:close="closeModal()" /> -->
				<ShipmentPopup :invoice="selected_invoice" :view_only="false" v-on:close="closeModal()" />
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'AbnormalInvoice'" :draggable="false">
			<template slot="title">Check Invoice Amount</template>
			<template slot="body">
				<div style="width:650px; height:400px;" v-on:keyup.esc="close()">
					<table class="list_tbl">
						<thead>
							<tr>
								<th width="13%">Ship To</th>
								<th width="13%">Bill To</th>
								<th width="12%">Invoice No</th>
								<th width="12%">Inv. Date</th>
								<th width="12%">S/O No</th>
								<th width="12%">S/O Date</th>
								<th width="12%">Inv. Amt.</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="ai in abnormal_invoices" v-bind:key="ai.invoice_no">
								<td class="al_left">{{ ai.ship_to_code }}</td>
								<td class="al_left">{{ ai.bill_to_code }}</td>
								<td class="al_left">
									<a href="javascript:;" @click="selectAbnormalInvoice(ai)">{{ ai.invoice_dn }}</a>
								</td>
								<td class="al_left">{{ ai.invoice_date }}</td>
								<td class="al_left">{{ ai.so_dn }}</td>
								<td class="al_left">{{ ai.so_date }}</td>
								<td class="al_right">{{ ai.invoice_amount | toCurrency }}</td>
							</tr>
						</tbody>
					</table>

					<div class="popup_bottom">
						<a href="javascript:;" @click="selectAbnormalInvoiceList()" class="normal_bt mgr_15">Refresh</a>
						<a href="javascript:;" @click="closeModal()" class="gray_bt">Close</a>
					</div>
				</div>
				<!-- <ShipmentPopup :invoice_no="selected_invoice_no" :view_only="true" v-on:close="closeModal()" /> -->
				<!-- <ShipmentPopup :invoice="selected_invoice" :view_only="false" v-on:close="closeModal()" /> -->
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'ViewItems'" :draggable="true">
			<template slot="title">Invoice No : {{ selected_invoice.invoice_dn }} Item(s)</template>
			<template slot="body">
				<SoItemPopup :invoice="selected_invoice" v-on:close="closeModal()" />
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import {
	apiInvoiceIndex,
	apiInvoicePrintDataList,
	apiSelectAbnormalInvoiceList,
	apiSelectInvoiceItemListForMerge,
	apiSelectInvoiceList,
	apiUpdateInvoicePrintList,
	apiChangeInvoiceDateBatch,
	apiSelectInvoiceItemList4Customer,
} from '@/api/sales/invoice.js';
import PageSizeSelect from '@/components/common/PageSizeSelect';
import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import Modal from '@/components/common/Modal';
import SoItemPopup from '@/components/common/SoItemPopup';
import ShipmentPopup from '@/components/common/ShipmentPopup';
import { today } from '@/utils/date.js';
import _ from 'lodash';
import { apiGetReportTemplate, companyMrtUrl, exportFile, getMrtFile, objectToUrlParam, PrintType, Report, reportMrtUrl, objectCopy } from '@/api/util';
import { apiSelectCompany } from '@/api/company';
import { exportDataExcel } from '@/api/util';
import { defaultDataType } from 'export-xlsx';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 0,
			page_no: 1,
			list_count: 0,

			invoice_type: 'S',
			invoice_date_from: today(),
			invoice_date_to: today(),
			sales_group_code: null,
			salesman_id: null,
			ship_to_code: null,
			bill_to_code: null,
			keyword: null,
			void_invoice: false,
			delivery_type_code: null,

			sort_key: 'invoice_date',
			sort_direction: 'DESC',

			salesGroups: [],
			salesmans: [],
			deliveryTypes: [],

			state: '',
			states: [],
			country: '',
			countries: [],

			invoices: [],
			abnormal_invoices: [],

			modalName: '',
			ship_or_bill: '',
			showModal: false,

			//total_amount_sum: 0,
			invoices_sum: {},

			selected_invoice: {},

			allSelected: false,

			dataForExcel: {
				itemList: [],
				partner: {},
				sumInvoice: {},
			},

			to_change_invoice_date: today(),

			exportPercent: 100,
			saveParam: {},

			territory_code: null,
			territories: [],

			date_non_select: false,

			from_invoice_no: null,
			to_invoice_no: null,

			temp_flag: null,
		};
	},
	computed: {
		filteredStates: function() {
			if (!this.country && this.user.company_id == 'newjigu') return this.states;

			var vm = this;
			var fStates = this.states.filter(s => s.country == vm.country);
			if (fStates.length == 0) vm.state = null;

			return fStates;
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
		profile: function() {
			return this.$session.get('profile');
		},
		is_admin() {
			return this.user && this.user.admin_yn === 'Y';
		},
		isBPorHP() {
			if (this.user.company_id == 'beautyplus' || this.user.company_id == 'hairplus') return true;
			else return false;
		},
		salesmansForSearch() {
			// return this.salesmans.map(sm => ({ code: sm.user_id, name: sm.name, sales_team_code: sm.sales_team_code }));
			if (this.sales_group_code && this.user.company_id == 'beautyplus') return this.salesmans.filter(sm => sm.sales_group_code == this.sales_group_code).map(sm => ({ code: sm.user_id, name: sm.name, sales_team_code: sm.sales_team_code }));

			return _.uniqBy(this.salesmans, 'user_id').map(sm => ({ code: sm.user_id, name: sm.name }));
		},
	},
	components: {
		CustomDatePicker,
		Paging,
		CodeSelect,
		PartnerSelect,
		Modal,
		ShipmentPopup,
		SoItemPopup,
		PageSizeSelect,
	},
	methods: {
		async excelSBM() {
			const { data } = await apiSelectInvoiceList(this.saveParam);
			var invoiceList = data.invoiceList || [];

			let header = [
				{ key: 'invoice_dn', name: 'Trans #', width: 15, dataType: defaultDataType.string },
				{ key: 'invoice_date', name: 'Trans Date', width: 14, dataType: defaultDataType.string },
				{ key: '', name: 'Type', width: 14 },
				{ key: '', name: 'Issued From', width: 14 },
				{ key: 'ship_to_code', name: 'Customer #', width: 15, dataType: defaultDataType.string },
				{ key: 'ship_to_name', name: 'Customer Name', width: 30, dataType: defaultDataType.string },
				{ key: 'sales_group_name', name: 'Sales Rep', width: 20, dataType: defaultDataType.string },
				{ key: 'payment_term_name', name: 'Terms', width: 15, dataType: defaultDataType.string },
				{ key: 'ship_to_address1', name: 'Ship To', width: 50, dataType: defaultDataType.string },
				{ key: 'delivery_type_name', name: 'Ship Via', width: 15, dataType: defaultDataType.string },
				{ key: 'freight_charge', name: 'Freight', width: 12, dataType: defaultDataType.currency },
				{ key: 'shipping_charge_discount_amount', name: 'Discount Charge', width: 12, dataType: defaultDataType.currency },
				{ key: 'invoice_amount', name: 'Total', width: 12, dataType: defaultDataType.currency },
				{ key: 'balance', name: 'Balance', width: 12, dataType: defaultDataType.currency },
				{ key: 'so_dn', name: 'Sales Order  #', width: 15, dataType: defaultDataType.string },
				{ key: 'customer_po_no', name: 'Customer PO #', width: 16, dataType: defaultDataType.string },
				{ key: '', name: 'Memo', width: 14 },
				{ key: '', name: 'Remark', width: 14 },
				{ key: 'crt_user', name: 'userID', width: 15, dataType: defaultDataType.string },
			];
			exportDataExcel(invoiceList, header, 'InvoiceSBM');
		},
		async excelItemList() {
			const { data } = await apiSelectInvoiceItemList4Customer({ from_invoice_no: this.from_invoice_no, to_invoice_no: this.to_invoice_no });
			//console.log(data);
			let header = [
				{ key: 'item_description', name: 'Description', width: 45, dataType: defaultDataType.string },
				{ key: 'item_code', name: "Vendor's Item #", width: 30, dataType: defaultDataType.string },
				{ key: 'item_abbr', name: 'PO #', width: 13, dataType: defaultDataType.string },
				{ key: 'so_date', name: 'PO Date', width: 13, dataType: defaultDataType.string },
				{ key: 'invoice_dn', name: 'Invoice #', width: 13, dataType: defaultDataType.string },
				{ key: 'invoice_date', name: 'Invoice Date', width: 13, dataType: defaultDataType.string },
				{ key: 'po_vendor', name: 'PO Vendor', width: 15, dataType: defaultDataType.string },
				{ key: 'ship_to_name', name: 'Ship To', width: 45, dataType: defaultDataType.string },
				{ key: 'class_name', name: 'Item Style', width: 40, dataType: defaultDataType.string },
				{ key: 'color_code', name: 'Item Attribute', width: 15, dataType: defaultDataType.string },
				{ key: 'unit_price', name: 'PO Line Unit Cost', width: 18, dataType: defaultDataType.number },
				{ key: 'quantity', name: 'ORDER_QTY', width: 15, dataType: defaultDataType.currency },
				{ key: 'shipped_quantity', name: 'PO Line Qty', width: 15, dataType: defaultDataType.currency },
				{ key: 'bo_quantity', name: 'Outstanding QTY', width: 17, dataType: defaultDataType.currency },
				{ key: 'barcode', name: 'UPC', width: 20, dataType: defaultDataType.string },
			];

			var file_name;
			if (this.from_invoice_no && this.to_invoice_no) file_name = this.from_invoice_no + '_' + this.to_invoice_no;
			else if (this.from_invoice_no) file_name = this.from_invoice_no;
			else file_name = this.to_invoice_no;
			exportDataExcel(data.invoiceItemList, header, file_name);
		},
		async excelExportOfAllData(selected_only) {
			let paramSelected = {};
			if (selected_only) {
				let invoiceNos = [];
				this.invoices.filter(i => i.selected && i.status_code != 'VI').forEach(value => invoiceNos.push(value.invoice_no));
				if (invoiceNos.length == 0) {
					this.$toast.error('No Data to Export.');
					return false;
				}
				paramSelected.invoice_nos = invoiceNos;
				paramSelected.sort_key = this.saveParam.sort_key;
				paramSelected.sort_direction = this.saveParam.sort_direction;
			} else {
				if (!this.list_count) {
					this.$toast.error('No Data to Export.');
					return false;
				}

				if (this.list_count > 50000) {
					this.$toast.error("Rows Over 50000 Can't Convert into Excel.");
					return;
				}
			}

			const filename = this.invoice_type === 'R' ? 'RETURN_INVOICE_LIST' : 'INVOICE_LIST';
			const { data } = await apiSelectInvoiceList(selected_only ? paramSelected : this.saveParam);

			const invoiceList = data.invoiceList || [];
			const invoicesSum = data.invoicesSum || {};

			if (invoiceList.length > 50000) {
				this.$toast.error("Rows Over 50000 Can't Convert into Excel.");
				return;
			}

			const headers = [
				{ key: 'ship_to_code', name: 'Ship To', width: 15, dataType: defaultDataType.string },
				{ key: 'ship_to_name', name: 'Name', width: 15, dataType: defaultDataType.string },
				{ key: 'ship_to_state', name: 'State', width: 15, dataType: defaultDataType.string },
				{ key: 'ship_to_country', name: 'Country', width: 15, dataType: defaultDataType.string },
				{ key: 'ship_to_address1', name: 'Address', width: 25, dataType: defaultDataType.string },
				{ key: 'bill_to_code', name: 'Bill To', width: 15, dataType: defaultDataType.string },
				{ key: 'bill_to_name', name: 'Name', width: 15, dataType: defaultDataType.string },
				{ key: 'invoice_dn', name: 'Inv. No', width: 15, dataType: defaultDataType.string },
				{ key: 'international_yn', name: 'International', width: 7, dataType: defaultDataType.string },
				{ key: 'invoice_date', name: 'Inv. Date', width: 10, dataType: defaultDataType.string },
				{ key: 'so_dn', name: 'S/O No', width: 15, dataType: defaultDataType.string },
				{ key: 'so_date', name: 'S/O date', width: 10, dataType: defaultDataType.string },
				{ key: 'crt_name', name: 'Entry By', width: 15, dataType: defaultDataType.string },
				{ key: 'sales_group_name', name: 'Sales Group', width: 15, dataType: defaultDataType.string },
				{ key: 'crt_name', name: 'Entry User', width: 15, dataType: defaultDataType.string },
				{ key: 'total_shipped_quantity', name: 'Quantity', width: 15, dataType: defaultDataType.currency },
				{ key: 'total_weight', name: 'Weight', width: 15, dataType: defaultDataType.number },
				{ key: 'total_shipped_amount', name: 'Total Amt.', width: 15, dataType: defaultDataType.number },
				{ key: 'invoice_amount', name: 'Inv. Amt.', width: 15, dataType: defaultDataType.number },
				{ key: 'box_count', name: 'Box', width: 15, dataType: defaultDataType.currency },
				{ key: 'payment_term_name', name: 'Payment Term', width: 15, dataType: defaultDataType.string },
				{ key: 'ship_charge_name', name: 'Ship Charge', width: 15, dataType: defaultDataType.string },
				{ key: 'delivery_type_name', name: 'Delivery Type', width: 15, dataType: defaultDataType.string },
				{ key: 'remark', name: 'Remark', width: 40, dataType: defaultDataType.string },
			];

			const sum_obj = {
				ship_to_code: 'TOTAL',
				total_shipped_quantity: invoicesSum.total_shipped_quantity_sum,
				total_weight: invoicesSum.total_weight,
				total_shipped_amount: invoicesSum.total_shipped_amount_sum,
				invoice_amount: invoicesSum.invoice_amount_sum,
				box_count: invoicesSum.box_count,
			};

			if (this.is_admin) {
				const idx = headers.findIndex(h => h.key === 'box_count'); // box_count위치에 insert
				headers.splice(idx, 0, { key: 'total_cost', name: 'Cost', width: 15, dataType: defaultDataType.number });
				sum_obj.total_cost = invoicesSum.total_cost_sum;
			}

			invoiceList.unshift(sum_obj);
			invoiceList.forEach(el => (el.international_yn = el.international ? 'Y' : ''));

			exportDataExcel(invoiceList, headers, filename);
		},
		async excelExportListSimple() {
			if (!this.list_count) {
				this.$toast.error('No Data to Export.');
				return false;
			}

			if (this.list_count > 50000) {
				this.$toast.error("Rows Over 50000 Can't Convert into Excel.");
				return;
			}

			// invoice_date별 subtotal행이 추가되므로 invoice_date 기준 오름차순으로 정렬
			const param = objectCopy(this.saveParam);
			param.sort_key = 'invoice_date';
			param.sort_direction = 'ASC';

			const filename = this.invoice_type === 'R' ? 'RETURN_INVOICE_LIST' : 'INVOICE_LIST';
			const { data } = await apiSelectInvoiceList(param);

			const invoiceList = data.invoiceList || [];
			const invoicesSum = data.invoicesSum || {};

			if (invoiceList.length > 50000) {
				this.$toast.error("Rows Over 50000 Can't Convert into Excel.");
				return;
			}

			this.subtotalByDate(invoiceList);

			const headers = [
				{ key: 'invoice_dn', name: 'Inv. No', width: 15, dataType: defaultDataType.string, editable: true },
				{ key: 'invoice_date', name: 'Inv. Date', width: 15, dataType: defaultDataType.string, editable: true },
				{ key: 'bill_to_code', name: 'Bill To', width: 15, dataType: defaultDataType.string, editable: true },
				{ key: 'bill_to_name', name: 'Name', width: 30, dataType: defaultDataType.string },
				{ key: 'invoice_amount', name: 'Inv. Amt.', width: 15, dataType: defaultDataType.number },
			];

			const sum_obj = {
				id: 'GrandTotal',
				invoice_dn: '',
				invoice_date: 'Grand Total',
				bill_to_code: '',
				bill_to_name: '',
				invoice_amount: invoicesSum.invoice_amount_sum,
			};

			invoiceList.push(sum_obj);
			exportDataExcel(invoiceList, headers, filename);
		},
		subtotalByDate(invoiceList) {
			if (!Array.isArray(invoiceList) || !invoiceList.length) return;

			// export되는 Excel File에서 Subtotal Row는 하이라이팅하기 위하여 id 부여
			let subtotal = { id: invoiceList[0].invoice_date, invoice_dn: '', invoice_date: invoiceList[0].invoice_date, bill_to_code: 'Total', bill_to_name: '', invoice_amount: 0 };
			for (let i = 0; i < invoiceList.length; i++) {
				if (subtotal.invoice_date === invoiceList[i].invoice_date) {
					subtotal.invoice_amount += invoiceList[i].invoice_amount;
				} else {
					const changed_invoice_date = invoiceList[i].invoice_date;
					invoiceList.splice(i, 0, subtotal);
					subtotal = { id: changed_invoice_date, invoice_dn: '', invoice_date: changed_invoice_date, bill_to_code: 'Total', bill_to_name: '', invoice_amount: 0 };
				}
			}

			invoiceList.push(subtotal);
		},
		changeInvoiceDate() {
			if (this.invoices.filter(invoice => invoice.selected).length == 0) {
				this.$toast.error('Nothing to change');
				return false;
			}

			this.modalName = 'ChangeInvoiceDate';
			this.showModal = true;
		},
		async changeInvoiceDateConfirm() {
			var param = {
				to_change_invoice_date: this.to_change_invoice_date,
				invoices: this.invoices.filter(invoice => invoice.selected),
			};

			const { data } = await apiChangeInvoiceDateBatch(param);

			if (data.result) {
				this.$toast.success('Changed successfully');
				this.invoices.filter(invoice => invoice.selected).forEach(i => (i.invoice_date = this.to_change_invoice_date));
				this.closeModal();
				//await this.search(false);
			} else {
				this.$toast.error(data.msg);
			}
			//console.log(param);
		},
		selectAbnormalInvoice(invoice) {
			let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice.invoice_no } });
			window.open(routeData.href, '_blank');
		},
		sortMark: function(sort_key) {
			if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'DESC';
			}
			this.selectInvoices();
			//console.log(sort_key);
		},
		internationalCreatable() {
			if (this.invoices.filter(invoice => invoice.selected).length == 0) {
				this.$toast.error('Nothing to export');
				return false;
			}

			var old_ship_to_code = null;
			var is_valid = true;

			this.invoices
				.filter(invoice => invoice.selected)
				.forEach(invoice => {
					//console.log(old_ship_to_code, invoice.ship_to_code);
					if (old_ship_to_code && invoice.ship_to_code != old_ship_to_code) is_valid = false;
					else if (invoice.ship_to_code != old_ship_to_code) old_ship_to_code = invoice.ship_to_code;
				});

			if (!is_valid) this.$toast.error('There is(are) different Ship To Invoice(s).');
			//console.log(is_valid);
			return is_valid;
		},
		selectAll() {
			//console.log(this.allSelected);
			var vm = this;
			this.invoices.forEach(function(invoice) {
				invoice.selected = vm.allSelected;
			});
		},
		shipmentPopup(invoice) {
			this.selected_invoice = invoice;
			this.modalName = 'Shipment';
			this.showModal = true;
		},
		viewItems(invoice) {
			this.selected_invoice = invoice;
			this.modalName = 'ViewItems';
			this.showModal = true;
		},
		aiPopup() {
			this.modalName = 'AbnormalInvoice';
			this.showModal = true;
		},
		setShipTo(partner) {
			this.ship_to_code = partner.code;
			this.search();
		},
		setBillTo(partner) {
			this.bill_to_co = partner.code;
			this.search();
		},
		selectInvoice(invoice) {
			// if (invoice.invoice_type == 'R') {
			// 	this.$toast.warning('Return SO will be developed later.');
			// 	return;
			// }
			//console.log(invoice);
			//this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath + '&from_main=true', invoice_no: invoice.invoice_no } });
			this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice.invoice_no } });
		},
		selectSO(invoice) {
			// if (invoice.invoice_type == 'R') {
			// 	this.$toast.warning('Return SO will be developed later.');
			// 	return;
			// }
			//console.log(invoice);
			this.$router.push({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice.invoice_no } });
		},
		async exportExcel() {
			//console.log('export');
			if (!this.internationalCreatable()) return;

			var invoice_nos = [];
			var invoice_dns = [];
			var filter_invoices = this.invoices.filter(invoice => invoice.selected);

			var temp_obj = {};
			filter_invoices.forEach(invoice => {
				invoice_nos.push(invoice.invoice_no);
				// 반복행을 이 열로출력
				if (temp_obj.el0) {
					temp_obj.el1 = invoice.invoice_dn;
					temp_obj = {};
				} else {
					temp_obj.el0 = invoice.invoice_dn;
					invoice_dns.push(temp_obj);
				}
			});

			const { data } = await apiSelectInvoiceItemListForMerge({
				first_invoice_no: this.invoices.filter(invoice => invoice.selected)[0].invoice_no,
				invoice_nos: invoice_nos,
			});

			this.dataForExcel = {
				itemList: data.invoiceItemList,
				partner: data.partner,
				sumInvoice: data.sumInvoice,
				invoice_dns: invoice_dns,
			};
			await apiSelectCompany().then(response => (this.dataForExcel.company = response.data.company));

			this.dataForExcel.itemList.forEach(i => {
				i.unit_price = i.unit_price * this.exportPercent * 0.01;
				i.shipped_amount = i.unit_price * i.shipped_quantity;
			});
			// stimulsoft {Today.ToString(..)} => 'MM-dd-yy'로 출력
			this.dataForExcel.sumInvoice.export_date = this.$moment(new Date()).format('MM/DD/YYYY');

			this.dataForExcel.sumInvoice.total_shipped_quantity = 0;
			this.dataForExcel.sumInvoice.total_shipped_amount = 0;
			this.dataForExcel.itemList.forEach(item => {
				this.dataForExcel.sumInvoice.total_shipped_quantity += item.shipped_quantity;
				this.dataForExcel.sumInvoice.total_shipped_amount += item.shipped_amount;
			});

			// console.log(JSON.stringify(this.dataForExcel, null, 4));

			const reportTemplate = await apiGetReportTemplate('CommercialInvoiceExcel', reportMrtUrl('CommercialInvoiceExcel'));
			const report = new Report(reportTemplate, this.dataForExcel, 'CommercialInvoiceExcel');
			exportFile(report, 'excel');
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectInvoices(pageNo);
		},
		// setSalesGroup(code) {
		// 	if (code) this.sales_group_code = code.code;
		// 	else this.sales_group_code = null;
		// },
		setPartner(partner) {
			//console.log(partner.code, partner.name);
			if (this.ship_or_bill == 'ship') this.ship_to_code = partner.code;
			else if (this.ship_or_bill == 'bill') this.bill_to_code = partner.code;
		},
		selectPartner(ship_or_bill) {
			this.ship_or_bill = ship_or_bill;
			this.modalName = 'PartnerSelect';
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		reset() {
			//this.sort_key = '';
			//this.sort_direction = 'DESC';

			this.invoice_date_from = today();
			this.invoice_date_to = today();
			this.sales_group_code = null;
			this.salesman_id = null;
			this.ship_to_code = null;
			this.bill_to_code = null;
			this.keyword = null;
			this.delivery_type_code = null;
			this.state = null;
			if (this.user.company_id == 'beautyplus' || this.user.company_id == 'hairplus') this.country = 'US';
			else this.country = null;
			this.territory_code = null;

			//this.selectInvoices();
			// this.dept_code = null;
		},
		async search() {
			await this.selectInvoices();
			if (this.modifiable) await this.selectAbnormalInvoiceList();

			if (this.invoices.length == 1 && this.keyword) this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: this.invoices[0].invoice_no } });
		},
		async selectAbnormalInvoiceList() {
			const { data } = await apiSelectAbnormalInvoiceList({ dummy: null });
			this.abnormal_invoices = data.abnormalInvoiceList;
		},
		async selectInvoices(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;
			//console.log('select invoices');
			//const { data } = await selectAllPensioner();

			var param = {
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,

				//invoice_type: 'S',
				state: this.state,
				country: this.country,
				territory_code: this.territory_code,
				invoice_type: this.invoice_type,
				status_code: this.void_invoice ? 'VI' : 'I',
				invoice_date_from: this.invoice_date_from,
				invoice_date_to: this.invoice_date_to,
				sales_group_code: this.sales_group_code,
				salesman_id: this.salesman_id,
				ship_to_code: this.ship_to_code,
				bill_to_code: this.bill_to_code,
				keyword: this.keyword,
				delivery_type_code: this.delivery_type_code,

				//order_by_invoice_dn: true,
				from_invoice_main: true,
			};
			if (param.country == 'ALL') param.country = '';

			if (param.keyword) param = _.omit(param, 'status_code');
			this.saveParam = {
				sort_key: param.sort_key,
				sort_direction: param.sort_direction,
				state: param.state,
				country: param.country,
				territory_code: param.territory_code,
				invoice_type: param.invoice_type,
				status_code: param.status_code,
				invoice_date_from: param.invoice_date_from,
				invoice_date_to: param.invoice_date_to,
				sales_group_code: param.sales_group_code,
				salesman_id: param.salesman_id,
				ship_to_code: param.ship_to_code,
				bill_to_code: param.bill_to_code,
				keyword: param.keyword,
				delivery_type_code: param.delivery_type_code,

				//order_by_invoice_dn: true,
				from_invoice_main: param.from_invoice_main,
			};

			if (this.temp_flag != null) {
				param.temp_flag = this.temp_flag;
				this.saveParam.temp_flag = this.temp_flag;
			}

			//if (!this.sort_key) param.order_by_invoice_dn = true;
			//console.log(param);

			const { data } = await apiSelectInvoiceList(param);
			// this.pensioners = data;
			// if (this.pensioners.length > 0 && this.selectedPsNo == null) {
			// 	this.selectRow(this.pensioners[0]);
			// }
			//console.log(data);
			this.invoices = data.invoiceList;
			this.invoices_sum = data.invoicesSum;
			this.list_count = data.invoicesSum.list_count; //data.list_count;
			//this.total_amount_sum = data.invoicesSum.total_amount_sum;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			var uri = '/sales/invoice_main?page_no=' + this.page_no;
			if (this.invoice_type) uri += '&invoice_type=' + this.invoice_type;
			if (this.keyword) uri += '&keyword=' + this.keyword;
			if (this.date_non_select) uri += '&invoice_date_from=NON_SELECT';
			else if (this.invoice_date_from) uri += '&invoice_date_from=' + this.invoice_date_from;
			if (this.date_non_select) uri += '&invoice_date_to=NON_SELECT';
			else if (this.invoice_date_to) uri += '&invoice_date_to=' + this.invoice_date_to;
			if (this.sales_group_code) uri += '&sales_group_code=' + this.sales_group_code;
			if (this.salesman_id) uri += '&salesman_id=' + this.salesman_id;
			if (this.ship_to_code) uri += '&ship_to_code=' + this.ship_to_code;
			if (this.bill_to_code) uri += '&bill_to_code=' + this.bill_to_code;
			if (this.delivery_type_code) uri += '&delivery_type_code=' + this.delivery_type_code;
			if (this.state) uri += '&state=' + this.state;
			if (this.country) uri += '&country=' + this.country;
			if (this.territory_code) uri += '&territory_code=' + this.territory_code;

			this.uri = uri + '&from_main=true';
			//window.history.replaceState({}, null, uri);
			window.history.pushState({}, null, uri);
			////this.$router.replace(uri).catch(err => err);
			//console.log(uri);
		},
		gotoPartner(code) {
			//console.log(code);
			this.$router.push({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.uri, code: code } });
		},
		postCoutryLoading() {
			//console.log(this.$route.query);
			if ((this.user.company_id == 'beautyplus' || this.user.company_id == 'hairplus') && !this.$route.query.from_main) this.country = 'US';
			//this.country = '';
		},
		async index() {
			const { data } = await apiInvoiceIndex();

			this.deliveryTypes = data.deliveryTypeList;
			this.salesGroups = data.salesGroupList;
			this.salesmans = data.salesmanList;
			this.states = data.stateList;
			this.countries = data.countryList;
			this.countries.unshift({ code: 'ALL', name: 'ALL' });
			this.territories = data.territoryList;
		},
		async init() {
			await this.index();

			if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;
			if (this.$route.query.invoice_type) this.invoice_type = this.$route.query.invoice_type;
			if (this.$route.query.invoice_date_from) {
				if (this.$route.query.invoice_date_from === 'NON_SELECT') {
					this.date_non_select = true;
					this.invoice_date_from = null;
				} else this.invoice_date_from = this.$route.query.invoice_date_from;
			}
			if (this.$route.query.invoice_date_to) {
				if (this.$route.query.invoice_date_to === 'NON_SELECT') this.invoice_date_to = null;
				else this.invoice_date_to = this.$route.query.invoice_date_to;
			}
			if (this.$route.query.sales_group_code) this.sales_group_code = this.$route.query.sales_group_code;
			if (this.$route.query.salesman_id) this.salesman_id = this.$route.query.salesman_id;
			if (this.$route.query.ship_to_code) this.ship_to_code = this.$route.query.ship_to_code;
			if (this.$route.query.bill_to_code) this.bill_to_code = this.$route.query.bill_to_code;
			if (this.$route.query.delivery_type_code) this.delivery_type_code = this.$route.query.delivery_type_code;
			if (this.$route.query.state) this.state = this.$route.query.state;
			if (this.$route.query.country) {
				if (this.$route.query.country === 'NON_SELECT') this.country = null;
				else this.country = this.$route.query.country;
			}
			if (this.$route.query.territory_code) this.territory_code = this.$route.query.territory_code;

			this.page_size = this.$store.getters['getDefaultPageSize'];
			//this.sort_key = this.user && this.user.company_id === 'minkhair' ? 'invoice_date' : this.user.company_id === 'newjigu' ? null : 'invoice_dn';

			await this.selectInvoices(this.$route.query.page_no);
			if (this.modifiable) await this.selectAbnormalInvoiceList();

			this.$nextTick(function() {
				this.$refs.keyword.focus();
			});
		},
		async invoicePrint() {
			if (this.invoices.filter(i => i.selected && i.status_code != 'VI').length === 0) {
				this.$toast.error('No valid invoice(s) selected.');
				return;
			}

			if (this.invoices.filter(i => i.selected && i.status_code == 'VI').length > 0) {
				this.$toast.warning('Excluded void invoice(s).');
			}

			let invoiceNos = [];
			this.invoices.filter(i => i.selected && i.status_code != 'VI').forEach(value => invoiceNos.push(value.invoice_no));

			await this.printPicking(invoiceNos);
		},
		async updateInvoicePrintList(list) {
			let invoice_no_arr = [];
			list.forEach(value => {
				//if (!value.invoice.invoice_print_user) invoice_no_arr.push(value.invoice.invoice_no);
				invoice_no_arr.push(value.invoice.invoice_no);
			});

			if (!invoice_no_arr.length) return;

			this.$nextTick(async () => {
				if (this.$store.getters.getShowModal) {
					let { status } = await apiUpdateInvoicePrintList(invoice_no_arr);
					if (status !== 200) this.$toast.error('Failed');
				}
			});
		},
		async printPicking(invoiceNos) {
			let file = 'invoice';
			if (this.invoice_type === 'R') file = 'ReturnList';

			let { data } = await apiInvoicePrintDataList(objectToUrlParam({ invoiceNos: invoiceNos }));
			if (data.result_code === 'success') {
				let list = [];
				// console.log(data);
				data.invoice.forEach(invoice => {
					list.push({ invoice: invoice });
				});

				// console.log(JSON.stringify(list, null, 4));
				const reportTemplate = await getMrtFile(companyMrtUrl(file));
				const report = new Report(reportTemplate, list, file, PrintType.List, true);
				// console.log('main');
				// console.log(report);
				this.$store.commit('setReport', report);
				this.updateInvoicePrintList(list); // invoice의 invoice_print_user/dt update

				return true;
			} else {
				this.$toast.error(data.errorSoList + ' An error has occurred.');
				return false;
			}
		},
	},
	created() {
		//this.$store.sideIndex = 3;
		this.$store.commit('setSideIndex', 3);
		//this.$store.selectedMenu = 'nav_li_6';
		this.$store.commit('setSelectedMenu', 'nav_li_invoice_main');
		this.$store.commit('setSubTitle', 'Sales -> Invoice');

		//this.selectInvoices();

		if (this.user.company_id == 'newjigu') this.invoice_type = null;

		if (this.user.temp_flag) {
			this.temp_flag = 1;
		}

		this.init();

		//console.log(this.user);

		//this.invoice.invoice_date = this.$moment(new Date()).format('MM-DD-YYYY');
		//this.invoice.so_date = today();
		//console.log(this.$moment(new Date()).format('MM-DD-YYYY HH:mm:ss'));

		//console.log(this.$session.get('time_zone'));
		//this.$moment.tz.setDefault(this.$session.get('time_zone'));
	},
	mounted() {
		inputSelectOnClick();
		//makeTableResizable();
	},
};
</script>

<style>
@keyframes blink-effect {
	50% {
		opacity: 0;
	}
}

.blink {
	animation: blink-effect 1s step-end infinite;

	/*
  animation-name: blink-effect;
  animation-duration: 1s;
  animation-iteration-count:infinite;
  animation-timing-function:step-end;
  */
}
</style>
